<template>
  <div class="app-contract-summary-wrapper"></div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import transaction from '@/mixins/transaction'

export default {
  name: 'ContractSummaryWrapper',
  data () {
    return {}
  },
  props: {
    successUrl: {
      type: String,
      default: '#'
    },
    againUrl: {
      type: String,
      default: '#'
    },
    failUrl: {
      type: String,
      default: '#'
    },
    expiredLinkUrl: {
      type: String,
      default: 'bestellung'
    },
    alreadyLinkUrl: {
      type: String,
      default: '/'
    },
    process: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions('contractSummary', [
      'contractSummaryStatus',
      'contractSummaryDeferredConfirm'
    ]),
    ...mapMutations('contractSummary', [
      'errorMessage',
      'setCSError',
      'setExpiredLinkUrl',
      'setAlreadyLinkUrl',
      'setProcess',
      'resetState'
    ])
  },
  computed: {
    ...mapGetters('contractSummary', [
      'confirmationStatus'
    ]),
    ...mapGetters([
      'getTechnicalErrorMsg'
    ])
  },
  mixins: [
    transaction('contractSummary')
  ],
  mounted () {
    this.resetState()
    this.startLoader() // Start the loader

    this.setExpiredLinkUrl(this.expiredLinkUrl)
    this.setAlreadyLinkUrl(this.alreadyLinkUrl)
    this.setProcess(this.process)
    this.processId = new URLSearchParams(window.location.search).get('processId')

    if (!this.processId) {
      this.setCSError(true)
      window.location.href = this.failUrl
      this.stopLoader()
      return
    }

    this.contractSummaryStatus({ processId: this.processId })
      .then((result) => {
        if (typeof result === 'string') {
          if (result.includes('9429') || result.includes('9405')) {
            window.location.href = this.againUrl
          } else {
            window.location.href = this.failUrl
          }
        } else {
          if (
            this.confirmationStatus === 'CON' &&
            result.contractSummaryInfo.deferredCSInfo?.expiryDate !== undefined
          ) {
            window.location.href = this.againUrl
          } else if (this.confirmationStatus === 'WAI') {
            return this.contractSummaryDeferredConfirm({ processId: this.processId })
          } else {
            this.errorMessage(this.getTechnicalErrorMsg)
            window.location.href = this.failUrl // Default-Err
          }
        }
      })
      .then((result) => {
        if (result && typeof result === 'string') {
          if (result.includes('9429') || result.includes('9405')) {
            window.location.href = this.againUrl
          } else {
            window.location.href = this.failUrl // GQL-Err
          }
        } else {
          window.location.href = this.successUrl // Success case
        }
      })
      .catch((error) => {
        console.error('Error:', error)
        window.location.href = this.failUrl
      })
      .finally(() => {
        this.stopLoader()
      })
  }
}
</script>
